<template>
  <!-- The new look (Seaded -> Intra uus raam ja Töölaud, like the calendar):
       the day-grouped list. Off, the table intra has always had. -->
  <event-feed v-if="features.intraFrame" />
  <event-list v-else :detailSearch="detailSearch">
    <template #top>
      <heading>
        Kalendri sissekanded
        <v-btn @click="openDetailSearch" color="primary">Detailne otsing</v-btn>
      </heading>
    </template>
  </event-list>
</template>

<script>
import EventList from '@/components/EventList.vue'
import EventFeed from '@/components/EventFeed.vue'
import { mapState } from 'vuex'

export default {
  components: { EventList, EventFeed },
  data () {
    return {
      detailSearch: false
    }
  },
  computed: {
    ...mapState(['features'])
  },
  methods: {
    openDetailSearch () {
      this.detailSearch = true
    }
  }
}
</script>
